const responseSurveys = {
    "payload": [
        {
            "surveyId": 1,
            "title": "Clima Laboral 2026",
            "status": "PUBLISHED",
            "questionCount": 10,
            "responseCount": 45,
            "createdAt": "2026-06-15T10:00:00",
            "startDate": "2026-07-01",
            "validUntil": "2026-07-31"
        },
        {
            "surveyId": 2,
            "title": "Satisfaccion del Colaborador",
            "status": "DRAFT",
            "questionCount": 5,
            "responseCount": 0,
            "createdAt": "2026-07-20T10:00:00",
            "startDate": "2026-08-01",
            "validUntil": "2026-08-15"
        },
        {
            "surveyId": 3,
            "title": "Evaluacion de Beneficios",
            "status": "CLOSED",
            "questionCount": 8,
            "responseCount": 120,
            "createdAt": "2026-04-10T10:00:00",
            "startDate": "2026-05-01",
            "validUntil": "2026-06-01"
        }
    ]
}

const responseQuestionTypes = {
    "payload": [
        { "id": 1, "name": "Texto Corto" },
        { "id": 2, "name": "Texto Largo" },
        { "id": 3, "name": "Seleccion Unica" },
        { "id": 4, "name": "Seleccion Multiple" }
    ]
}

const responseSurveyDetail = {
    "payload": {
        "surveyId": 1,
        "name": "Clima Laboral 2026",
        "description": "Queremos conocer tu opinion para seguir mejorando el ambiente laboral juntos.",
        "startDate": "2026-07-01",
        "endDate": "2026-07-31",
        "status": "Activa",
        "allowMultipleResponses": true,
        "questions": [
            {
                "questionId": 1,
                "questionTypeId": 1,
                "questionTypeName": "Texto Corto",
                "text": "Como te sientes trabajando en la compania?",
                "required": true,
                "options": []
            },
            {
                "questionId": 2,
                "questionTypeId": 3,
                "questionTypeName": "Seleccion Unica",
                "text": "Como calificas tu experiencia en la empresa?",
                "required": true,
                "options": ["Excelente", "Buena", "Regular", "Mala"]
            }
        ]
    }
}

const responseCreateSurvey = {
    status: 200,
    data: {
        "payload": {
            "surveyId": 4,
            "message": "Encuesta creada exitosamente"
        }
    }
}

const responseUpdateSurvey = {
    status: 200,
    data: {
        "payload": {
            "surveyId": 1,
            "message": "Encuesta actualizada exitosamente"
        }
    }
}

const responseFinalizeSurvey = {
    status: 200,
    data: {
        "payload": {
            "surveyId": 1,
            "message": "Encuesta finalizada exitosamente"
        }
    }
}

export const service = {
    getListSurveys: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseSurveys }), 1000);
    }),
    getSurveyById: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseSurveyDetail }), 1000);
    }),
    getQuestionTypes: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseQuestionTypes }), 1000);
    }),
    postCreateSurvey: () => new Promise(resolve => {
        setTimeout(resolve(responseCreateSurvey), 1000);
    }),
    putUpdateSurvey: () => new Promise(resolve => {
        setTimeout(resolve(responseUpdateSurvey), 1000);
    }),
    putFinalizeSurvey: () => new Promise(resolve => {
        setTimeout(resolve(responseFinalizeSurvey), 1000);
    })
}
